import {
  Component,
  OnInit,
  Inject
} from '@angular/core';

@Component({
  selector: 'app-expandable-contact-form',
  templateUrl: './expandable-contact-form.component.html',
  styleUrls: ['./expandable-contact-form.component.scss']
})

export class ExpandableContactFormComponent implements OnInit {
  isOpen: boolean = false;
  timer: any;
  isVisible: boolean = true;

  constructor(
    @Inject('WINDOW') private window: any
  ) { }

  ngOnInit(): void {
    if (this.window) {
      // this.refreshTimer();
    }
  }

  refreshTimer(): void {
    clearInterval(this.timer);

    this.timer = setInterval(
      () => {
        if (!this.isOpen)
          this.isVisible = false;
      },
      2000
    );
  }

  onScroll(): void {
    this.isVisible = true;

    if (this.window) {
      // this.refreshTimer();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/expandable-contact-form/expandable-contact-form.component.ts